const SITE_ITEM_HOSTS = {
  MLA: 'https://articulo.mercadolibre.com.ar',
  MLB: 'https://produto.mercadolivre.com.br',
  MLM: 'https://articulo.mercadolibre.com.mx',
  MLC: 'https://articulo.mercadolibre.cl',
  MCO: 'https://articulo.mercadolibre.com.co',
  MLU: 'https://articulo.mercadolibre.com.uy',
  MPE: 'https://articulo.mercadolibre.com.pe',
  MEC: 'https://articulo.mercadolibre.com.ec',
  MLV: 'https://articulo.mercadolibre.com.ve',
  MCR: 'https://articulo.mercadolibre.com.cr',
  MRD: 'https://articulo.mercadolibre.com.do',
  MPA: 'https://articulo.mercadolibre.com.pa',
  MBO: 'https://articulo.mercadolibre.com.bo',
};

export const hyphenateMercadolibreItemId = itemId =>
  String(itemId || '').replace(/^([A-Z]+)(\d+)/, '$1-$2');

export const mercadolibreItemFromAttributes = (attrs = {}) => {
  const itemId = attrs.item_id || attrs.itemId || '';
  const title = attrs.item_title || attrs.itemTitle || '';
  const thumbnail = attrs.item_thumbnail || attrs.itemThumbnail || '';
  const price = attrs.item_price || attrs.itemPrice || '';
  const stock = attrs.item_stock ?? attrs.itemStock;
  const siteId = attrs.site_id || attrs.siteId || 'MLA';
  const storedPermalink = attrs.item_permalink || attrs.itemPermalink || '';
  const permalink =
    storedPermalink ||
    (itemId
      ? `${SITE_ITEM_HOSTS[siteId] || SITE_ITEM_HOSTS.MLA}/${hyphenateMercadolibreItemId(itemId)}`
      : '');

  if (!title && !itemId) return null;

  return {
    itemId,
    title: title || itemId,
    thumbnail,
    price,
    stock,
    permalink,
  };
};
